'use client';
import Link from 'next/link';
import { useEffect } from 'react';

export default function Error({ error, reset }) {
    useEffect(() => {
        // Optionally log error to an error reporting service
        // console.error(error);
    }, []);

    return (
        <section className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white">
            <h1 className="text-6xl font-bold mb-4 text-brand">500</h1>
            <h2 className="text-2xl font-semibold mb-2">
                Something Went Wrong
            </h2>
            <p className="mb-6 text-gray-300">
                Sorry, an unexpected error has occurred. Please try again or
                return home.
            </p>
            <div className="flex gap-4">
                <button
                    type="button"
                    onClick={() => reset()}
                    className="bg-brand hover:bg-white hover:text-brand text-white px-6 py-3 rounded-none border border-brand font-semibold transition hover:cursor-pointer cursor-pointer"
                >
                    Try Again
                </button>
                <Link
                    href="/"
                    className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-3 rounded-none font-semibold transition hover:cursor-pointer"
                >
                    Go Home
                </Link>
            </div>
        </section>
    );
}
